module.exports = __webpack_public_path__ + "img/brand-32.9878b954.png";